import api, { adminApiPrefix } from './Api';
import {
  Review,
  reviewFromResponse,
  reviewToUpsertRequest,
} from '../interfaces/Review/Review';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  ReviewFilter,
  reviewFilterToParams,
} from '../interfaces/Review/ReviewFilter';

const reviewAdminApiPrefix = `${adminApiPrefix}/review`;

export const getReviews = async (
  filter: ReviewFilter,
): Promise<PaginatedResponse<Review>> => {
  const response = await api.get(reviewAdminApiPrefix, {
    params: reviewFilterToParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map((review: any) =>
      reviewFromResponse(review),
    ),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getReview = async (id: number): Promise<Review> => {
  const response = await api.get(`${reviewAdminApiPrefix}/${id}`);

  return reviewFromResponse(response.data?.data);
};

export const updateReview = async (review: Review): Promise<void> =>
  api.put(
    `${reviewAdminApiPrefix}/${review.id}`,
    reviewToUpsertRequest(review),
  );

export const deleteReview = async (id: number): Promise<void> =>
  api.delete(`${reviewAdminApiPrefix}/${id}`);
